export const SCORES_LIST_WIDGET = {
  TYPES: {
    all: 'all',
    my: 'my'
  },
  ACTION_TYPES: {
    loadMore: 'loadMore',
    showAll: 'showAll',
    competitionsFetch: 'competitionsFetch'
  }
}
